module.exports = __webpack_public_path__ + "img/Strategy-24.c0252d9e.svg";